import { render, staticRenderFns } from "./HouseProfile.vue?vue&type=template&id=34afe0b2&scoped=true&"
import script from "./HouseProfile.vue?vue&type=script&lang=js&"
export * from "./HouseProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34afe0b2",
  null
  
)

export default component.exports